export default __webpack_public_path__ + "static/media/pnsv_stand_Kenworth.70e11963.png";